// Keeps Buy it now in step with Add to cart on product pages. When Add to cart is disabled
// (sold out, or an unavailable variant), Buy it now is made inert so it can't be tapped, focused
// or read out; it comes back as soon as Add to cart is enabled again, e.g. after a variant change.
// The faded look comes from component-product-buttons.css.
(() => {
  const sync = (container) => {
    const submit = container.querySelector('.product-form__submit');
    const payment = container.querySelector('.shopify-payment-button');
    if (!submit || !payment) return;
    payment.inert = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
  };

  const watch = (root) => {
    root.querySelectorAll('.product__info-container').forEach((container) => {
      sync(container);
      new MutationObserver(() => sync(container)).observe(container, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled'],
      });
    });
  };

  watch(document);
  document.addEventListener('shopify:section:load', (event) => watch(event.target));
})();
